module.exports = __webpack_public_path__ + "static/media/rodape-logo-istagram.e7327214.png";